import { Component } from '@angular/core';
import { ShoppingComponent } from "../shopping/shopping.component";

@Component({
    selector: 'home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    imports: [ShoppingComponent],
})
export class HomeComponent { }
